import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/src/app/dashboard/isolated/page.tsx");
